import React from "react";

const AssignmentMetaForm = ({ meta, setMeta, batches }) => (
  <div className="asgn-form__grid">
    <div className="asgn-form__field">
      <label className="asgn-form__label">Assignment Title *</label>
      <input
        className="asgn-form__input"
        value={meta.title}
        onChange={e => setMeta(m => ({ ...m, title: e.target.value }))}
        placeholder="Enter assignment title"
        required
      />
    </div>
    <div className="asgn-form__field">
      <label className="asgn-form__label">Batch *</label>
      <select
        className="asgn-form__select"
        value={meta.batch}
        onChange={e => setMeta(m => ({ ...m, batch: e.target.value }))}
        required
      >
        <option value="">Select batch</option>
        {batches.map(b => (
          <option key={b._id} value={b._id}>
            {b.course?.name || 'Unknown Course'} - {b.name}
          </option>
        ))}
      </select>
    </div>
    <div className="asgn-form__field">
      <label className="asgn-form__label">Start Date/Time *</label>
      <input
        className="asgn-form__input"
        type="datetime-local"
        value={meta.startDate}
        onChange={e => setMeta(m => ({ ...m, startDate: e.target.value }))}
        required
      />
    </div>
    <div className="asgn-form__field">
      <label className="asgn-form__label">End Date/Time *</label>
      <input
        className="asgn-form__input"
        type="datetime-local"
        value={meta.endDate}
        onChange={e => setMeta(m => ({ ...m, endDate: e.target.value }))}
        required
      />
    </div>
    <div className="asgn-form__field asgn-form__field--full">
      <label className="asgn-form__label">Description</label>
      <textarea
        className="asgn-form__textarea"
        rows={2}
        value={meta.description}
        onChange={e => setMeta(m => ({ ...m, description: e.target.value }))}
        placeholder="Optional description for the assignment"
      />
    </div>
    <div className="asgn-form__field">
      <label className="asgn-form__label">Time Limit (minutes)</label>
      <input
        className="asgn-form__input"
        type="number"
        min={0}
        value={meta.timeLimit}
        onChange={e => setMeta(m => ({ ...m, timeLimit: e.target.value }))}
        placeholder="e.g., 60"
      />
    </div>
    <div className="asgn-form__field">
      <label className="asgn-form__label">Assignment Type *</label>
      <select
        className="asgn-form__select"
        value={meta.assignmentType}
        onChange={e => setMeta(m => ({ ...m, assignmentType: e.target.value }))}
        required
      >
        <option value="exam">Exam</option>
        <option value="practice">Practice</option>
      </select>
    </div>
  </div>
);

export default AssignmentMetaForm;
